<section class="promotional_sect login-page">
  <a href="javascript:void(0)" routerLink="/login" class="cross-icon">
    <span class="icon-close"></span>
  </a>
  <div class="content_sect">
    <div class="content_text">
      <div class="content_box">
        <div class="left-content">
          <img src="assets/images/logo-white.svg" />
          <div class="login-info">
            <h2>
              {{ "RESET_PASSWORD.RESET_PASSWORD" | translate }}
            </h2>
            {{ "RESET_PASSWORD.SET_YOUR_PASSWORD" | translate }}
          </div>
        </div>

        <div class="right-login">
          <div class="w-100">
            <form
              (ngSubmit)="submit(loginForm.valid)"
              class="login"
              #loginForm="ngForm"
            >
              <div class="form-group position-relative password-in">
                <div class="field-icon">
                  <span class="material-icons"> lock_open </span>
                </div>
                <div class="pass-ic">
                  <span
                    class="icon-eye-closed"
                    (click)="changePasswordType('password')"
                    [ngClass]="{
                      'icon-eye-icon': passwordType == 'password',
                      'icon-eye-closed': passwordType != 'password'
                    }"
                  ></span>
                </div>
                <label> {{ "RESET_PASSWORD.PASSWORD" | translate }}</label>
                <input
                  maxlength="30"
                  minlength="6"
                  id="password"
                  type="{{ passwordType }}"
                  placeholder="{{
                    'RESET_PASSWORD.PLACEHOLDER_PASSWORD' | translate
                  }}"
                  #password="ngModel"
                  class="form-control with-icon-field login-fields"
                  name="password"
                  [(ngModel)]="model.password"
                  required
                />

                <div
                  style="color: red"
                  class="validation_div"
                  *ngIf="
                    password.errors &&
                    (password.dirty || password.touched || loginForm.submitted)
                  "
                >
                  <p class="mb-0" *ngIf="password.errors.required">
                    {{ "RESET_PASSWORD.PASSWORD_REQUIRED" | translate }}
                  </p>
                  <p class="mb-0" *ngIf="password.errors.minlength">
                    {{ "PERSONAL_INFO.MINLENGTH_PASSWORD" | translate }}
                  </p>
                </div>
              </div>

              <div class="form-group position-relative password-in">
                <div class="field-icon">
                  <span class="material-icons"> lock_open </span>
                </div>
                <div class="pass-ic">
                  <span
                    class="icon-eye-closed"
                    (click)="changePasswordType('confirmPassword')"
                    [ngClass]="{
                      'icon-eye-icon': confirmPasswordType == 'password',
                      'icon-eye-closed': confirmPasswordType != 'password'
                    }"
                  ></span>
                </div>
                <label>
                  {{ "RESET_PASSWORD.CONFIRM_PASSWORD" | translate }}</label
                >
                <input
                  maxlength="30"
                  minlength="6"
                  id="confirm_password"
                  type="{{ confirmPasswordType }}"
                  placeholder="{{
                    'RESET_PASSWORD.PLACEHOLDER_CONFIRM_PASSWORD' | translate
                  }}"
                  #confirm_password="ngModel"
                  class="form-control with-icon-field password-fields"
                  name="confirm_password"
                  [(ngModel)]="model.confirm_password"
                  required
                />
                <div
                  style="color: red"
                  class="validation_div"
                  *ngIf="model.confirm_password != model.password"
                >
                  <p class="text-danger mb-0">
                    {{ "RESET_PASSWORD.MISMATCH_PASSWORD" | translate }}
                  </p>
                  
                </div>
              </div>
              <div class="d-flex justify-content-center">
                <button
                  class="btn btn-theme btn-login"
                  [disabled]="
                    !loginForm.valid ||
                    model.confirm_password !== model.password
                  "
                >
                  <span class="spin icon-loader" *ngIf="isLoading"> </span>
                  {{ "RESET_PASSWORD.SUBMIT" | translate }}
                </button>
              </div>
            </form>
            <div
              class="bottom-signup text-center para-color-gray para-color-gray"
            >
              <a
                routerLink="/login"
                href="javascript:void(0)"
                class="orange-link"
              >
                {{ "SIGNUP_INFO.BACK_TO_LOGIN" | translate }}</a
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
